export default function accountProgressSelector(store, ownProps) {
	return {
		...store.account,
		...store.knowledge
	};
}